// extracted by mini-css-extract-plugin
export var dividerContainer = "_91-0";
export var line = "_91-1";